import { Box, HStack, Icon, Pressable, Text } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

export const Container = HStack.withConfig({
  alignItems: 'center',
});

export const ClickableWrapper = Pressable.withConfig<{ isInCart: boolean; hasAlert: boolean }>(
  p => ({
    flexDirection: 'row',
    alignItems: 'center',
    height: p.isInCart ? 'auto' : p.hasAlert ? '$14' : '$12',
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 'auto',
    marginRight: '$1',
    _web: {
      cursor: 'pointer',
    },
  })
);

export const IconContainer = Box.withConfig({
  marginLeft: { base: 0, md: '$1' },
  marginRight: '$2',
});

export const DetailsWrapper = Box.withConfig({
  flexGrow: 1,
});

export const DetailsContainer = HStack.withConfig({
  alignItems: 'center',
  flex: 1,
});

export const Heading = Text.withConfig({
  fontFamily: 'heading',
  numberOfLines: 1,
  fontSize: 'md',
});

export const Details = Text.withConfig<{ isInCart: boolean }>(p => ({
  flex: 1,
  numberOfLines: 1,
  overflow: 'hidden',
  paddingLeft: p.isInCart ? '$0' : '$2',
  fontSize: 'md',
  maxWidth: p.isInCart ? '100%' : '2/3',
  marginRight: {
    md: '$2',
  },
  paddingRight: '$1',
  _web: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

export const SmartAlertText = Text.withConfig({
  flex: 1,
  numberOfLines: 1,
  overflow: 'hidden',
  fontSize: 'xs',
  lineHeight: 'xs',
  fontWeight: 'bold',
  color: theme.token('text-default'),
  _web: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

export const ButtonWrapper = Box.withConfig({});

export const IconStyled = Icon.withConfig({
  size: '5',
  ...hiddenAccessibilityPlatformProps,
});

export const ArrowRightIcon = Icon.withConfig({
  variant: 'back',
  size: {
    base: 'xs',
    md: 'sm',
  },
  mt: {
    base: '$0.5',
    md: '$1',
  },
  style: {
    transform: [{ rotate: '180deg' }],
  },
});
